import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  DownloadBtn,
} from "../../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import NotFoundModel from "../../../Components/NotFoundModel";
import moment from "moment";
import AddFoodMenu from "../../../Components/FoodMenu/AddFoodMenu";
import { toast } from "react-toastify";
import ConfirmPublish from "../../../Components/FoodMenu/ConfirmPublish";
import SideModal from "../../../Components/SideModal";
import {
  FiAlertCircle,
  FiClock,
  FiCheckCircle
} from "react-icons/fi";
import { FaBuilding, FaConciergeBell, FaCookieBite, FaUtensils } from "react-icons/fa";
import { MdOutlineChevronRight, MdOutlineFastfood, MdRestaurantMenu } from "react-icons/md";
import PropertiesFilterDropdown from "../../../Components/PropertiesFilterDropdown";
import UploadMenu from "../../../Components/FoodMenu/UploadMenu";

const FoodMenu = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [apiData, setApiData] = useState([]);
  const [activeDay, setActiveDay] = useState(1);
  // const [activeDay, setActiveDay] = useState(null);
  const [key, setKey] = useState("");
  const [isFoodMenu, setIsFoodMenu] = useState(false);
  const [isUploadMenuVisible, setIsUploadMenuVisible] = useState(false);
  const [isPublishMenu, setIsPublishMenu] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [mobileSearchTerm, setMobileSearchTerm] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const filteredProperties = propertyList?.filter((prop) =>
    prop.id !== 0 &&
    prop.name?.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  const mobileFilteredProperties = propertyList?.filter((prop) =>
    prop.id !== 0 &&
    prop.name?.toLowerCase().includes(mobileSearchTerm.toLowerCase())
  ) || [];

  const query = `&propId=${selectedProperty}`;

  useEffect(() => {
    if (propertyList && propertyList.length > 0 && !selectedProperty) {
      const firstProperty = propertyList.find(prop => prop.id !== 0);
      if (firstProperty) {
        setSelectedProperty(firstProperty.id);
      }
    }
  }, [propertyList, selectedProperty]);

  const fetchFunction = async () => {
    if (!selectedProperty || selectedProperty === 0) {
      setApiData([]);
      setIsDataLoaded(true);
      return { isSuccess: false, data: [] };
    }

    const response = await axios.get(
      `${Config.apiUrl}/food/list/prop/menu?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      error = true;
      setIsDataLoaded(true);
    } else {
      setApiData(res?.data || []);
      const today = new Date().getDay() || 7;
      const hasToday = res?.data?.some((item) => item.dayOfWeek === today);
      setActiveDay(hasToday ? today : 1);
      setIsDataLoaded(true);
    }
    setIsInitialLoad(false);
  };

  const getError = (res) => {
    setIsDataLoaded(true);
    setIsInitialLoad(false);
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (selectedProperty && selectedProperty !== 0) {
      setIsDataLoaded(false);
      const handler = setTimeout(() => {
        getListMutate();
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [selectedProperty]);

  const handlePropertySelect = (property) => {
    handlePropertyChange(property?.id);
    setApiData([]);          // Clear previous property's menu
    setIsDataLoaded(false);  // Show loader
    setActiveDay(1);
  }

  const handlePropertyChange = (id) => {
    setSelectedProperty(id);
    setActiveDay(1); // Reset to Monday when changing property
  };

  const dayNames = {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday",
  };

  const getDayMenu = (day) => {
    return apiData.find((item) => item.dayOfWeek === day);
  };

  const getAllDays = () => {
    return Array.from({ length: 7 }, (_, i) => i + 1).map((day) => ({
      dayOfWeek: day,
      name: dayNames[day],
      hasData: !!getDayMenu(day),
    }));
  };

  //------- Add Menu -------
  const addMenuFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/food/add/day/menu`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsFoodMenu(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addMenuLoading, mutate: addMenuMutate } = useMutation(
    addMenuFunction,
    {
      onSuccess: onAddMenuSuccess,
      onError: onAddMenuError,
    }
  );

  //------- Edit Menu -------
  const editMenuFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/food/edit/day/menu`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsFoodMenu(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editMenuLoading, mutate: editMenuMutate } = useMutation(
    editMenuFunction,
    {
      onSuccess: onEditMenuSuccess,
      onError: onEditMenuError,
    }
  );

  //------- Replicate Menu -------
  const replicateMenuFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/food/replicate/day/menu`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onReplicateMenuSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onReplicateMenuError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: replicateMenuLoading, mutate: replicateMenuMutate } =
    useMutation(replicateMenuFunction, {
      onSuccess: onReplicateMenuSuccess,
      onError: onReplicateMenuError,
    });

  const handleReplicateMenu = () => {
    const currentMenu = getDayMenu(activeDay);
    if (currentMenu) {
      replicateMenuMutate({
        propId: selectedProperty,
        dayOfWeek: currentMenu.dayOfWeek,
        breakfast: currentMenu.breakfast || "",
        breakfastTiming: currentMenu.breakfastTiming || "",
        lunch: currentMenu.lunch || "",
        lunchTiming: currentMenu.lunchTiming || "",
        snacks: currentMenu.snack || "",
        snacksTiming: currentMenu.snackTiming || "",
        dinner: currentMenu.dinner || "",
        dinnerTiming: currentMenu.dinnerTiming || "",
        lunchNonVeg: currentMenu.lunchNonVeg || "",
        dinnerNonVeg: currentMenu.dinnerNonVeg || "",
      });
    }
  };

  const handleClose = () => {
    setIsFoodMenu(false);
  };

  const isDayWithMenu = (day) => {
    return apiData.some((item) => item.dayOfWeek === day);
  };

  const { mutate: publishMenuMutate, isLoading: publishMenuLoading } =
    useMutation(
      async ({ propId, status }) => {
        const publishQuery = `propId=${propId}&isFoodPublished=${status}`;

        const response = await axios.get(
          `${Config.apiUrl}/food/publish/menu?${publishQuery}`,
          {
            headers: {
              authorization: "Bearer" + " " + user.token,
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        );
        return response.data;
      },
      {
        onSuccess: (res) => {
          if (res.isSuccess === false) {
            toast.error(res?.msg || "Operation failed");
          } else {
            toast.success(res?.msg || "Operation successful");
            setIsPublishMenu(false);
            getListMutate();
          }
        },
        onError: (error) => {
          toast.error(error?.response?.data?.msg || "An error occurred");
        },
      }
    );
  //------- Upload Menu Model -------
  const UploadMenuFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/food/update/menu/excel`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const uploadMenuSuccess = (data) => {
    setIsUploadMenuVisible(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const uploadMenuError = (data) => {
    setIsUploadMenuVisible(false);
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: uploadMenuLoading, mutate: uploadMenuMutate } =
    useMutation(UploadMenuFunction, {
      onSuccess: uploadMenuSuccess,
      onError: uploadMenuError,
    });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Food Menu
          <Underline />
        </BoxTitle>
      </BoxHead>
      {/* Mobile Property Selector - Visible only on mobile */}

      <div className="max-w-7xl mx-auto pb-2">

        <div className="mb-6 flex justify-between items-center">

          <div>
            <p className="text-sm text-gray-500">
              Manage weekly menu for your property
            </p>
          </div>

          <div className="ml-auto">
            <PropertiesFilterDropdown
              properties={filteredProperties}
              selectedProperty={filteredProperties.find(
                p => p.id === selectedProperty
              ) || null}
              onPropertySelect={handlePropertySelect}
              placeholder="Select Property"
              className="min-w-[200px] w-full md:w-[220px]"
            />
          </div>
          {/* <div className="w-[340px] ml-auto">
            <Autocomplete
              options={filteredProperties}
              value={
                filteredProperties.find(
                  p => p.id === selectedProperty
                ) || null
              }
              onChange={(_, value) => {
                if (value) {
                  handlePropertyChange(value.id);
                }
              }}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search Property..."
                  size="small"
                />
              )}
            />
          </div> */}
        </div>

        <div className="w-full overflow-y-auto mb-4">
          <SideModal
            isOpen={isFoodMenu}
            onClose={() => setIsFoodMenu(false)}
          >
            <AddFoodMenu
              setIsFoodMenu={setIsFoodMenu}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              addMenuLoading={addMenuLoading}
              addMenuMutate={addMenuMutate}
              editMenuLoading={editMenuLoading}
              editMenuMutate={editMenuMutate}
              handleClose={handleClose}
              propId={selectedProperty}
            />
          </SideModal>

          <SideModal
            isOpen={isUploadMenuVisible}
            onClose={() => setIsUploadMenuVisible(false)}
          >
            <UploadMenu
              setIsUploadMenuVisible={setIsUploadMenuVisible}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              uploadMenuLoading={uploadMenuLoading}
              uploadMenuMutate={uploadMenuMutate}
              propId={selectedProperty}
            />
          </SideModal>

          {isPublishMenu && (
            <ConfirmPublish
              publishMenuMutate={publishMenuMutate}
              publishMenuLoading={publishMenuLoading}
              setIsPublishMenu={setIsPublishMenu}
              selectedData={selectedData}
              propId={selectedProperty}
              data={data}
            />
          )}


          {(!isDataLoaded || isLoading || isRefetching) && <Loading />}

          {!selectedProperty || selectedProperty === 0 ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-center p-8">
                <div className="text-gray-400 mb-4">
                  <FaBuilding className="w-16 h-16 mx-auto" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">No Property Selected</h3>
                <p className="text-gray-500">Please select a property from the dropdown above to view its food menu.</p>
              </div>
            </div>
          ) : (
            isDataLoaded &&
            !isLoading &&
            !error && (
              <>
                <DayTabsContainer>
                  {selectedProperty && !isLoading && getAllDays().map((day) => (
                    <DayTab
                      key={day.dayOfWeek}
                      $active={activeDay === day.dayOfWeek}
                      $hasData={day.hasData}
                      onClick={() => setActiveDay(day.dayOfWeek)}
                    >
                      {day.name}

                      {/* {day.hasData && (
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                      )} */}
                    </DayTab>
                  ))}
                </DayTabsContainer>
                <>

                  <div className="pt-2">
                    <div className="flex md:flex-row flex-col justify-between items-center mb-4">
                      <h2 className="text-lg font-semibold text-gray-800 mb-2 md:mb-0">
                        {dayNames[activeDay]}'s Menu
                      </h2>

                      <div className="flex justify-between items-center gap-2">
                        {apiData.length === 1 && isDayWithMenu(activeDay) && (
                          <AddBtn
                            type="button"
                            onClick={handleReplicateMenu}
                            disabled={replicateMenuLoading}
                          >
                            {replicateMenuLoading
                              ? "Replicating..."
                              : "Replicate on all days"}
                          </AddBtn>
                        )}
                        {/* <DownloadBtn
                          type="button"
                          onClick={() => {
                            setIsUploadMenuVisible(true);
                          }}
                        >
                          Upload Menu
                        </DownloadBtn> */}
                        {getDayMenu(activeDay) && (
                          <DownloadBtn
                            type="button"
                            onClick={() => {
                              setKey(moment().unix());
                              setSelectedData(getDayMenu(activeDay));
                              setIsFoodMenu(true);
                            }}
                          >
                            Edit Menu
                          </DownloadBtn>
                        )}
                      </div>
                    </div>

                    {/* {getDayMenu(activeDay) ? ( */}
                    {activeDay && getDayMenu(activeDay) ? (
                      <div className="grid md:grid-cols-2 gap-6 mb-20 md:mb-0">

                        <MealCardX
                          icon={<MdOutlineFastfood />}
                          title="Breakfast"
                          timing={getDayMenu(activeDay)?.breakfastTiming}
                          single={getDayMenu(activeDay)?.breakfast}
                          emptyMessage="Breakfast menu not available."
                          onEdit={() => {
                            setKey(moment().unix());
                            setSelectedData(getDayMenu(activeDay));
                            setIsFoodMenu(true);
                          }}
                        />

                        <MealCardX
                          icon={<FaUtensils />}
                          title="Lunch"
                          timing={getDayMenu(activeDay)?.lunchTiming}
                          veg={getDayMenu(activeDay)?.lunch}
                          nonVeg={getDayMenu(activeDay)?.lunchNonVeg}
                          emptyMessage="Lunch menu not available."
                          onEdit={() => {
                            setKey(moment().unix());
                            setSelectedData(getDayMenu(activeDay));
                            setIsFoodMenu(true);
                          }}
                        />

                        <MealCardX
                          icon={<FaCookieBite />}
                          title="Snacks"
                          timing={getDayMenu(activeDay)?.snackTiming}
                          single={getDayMenu(activeDay)?.snack}
                          emptyMessage="Snacks menu not available."
                          onEdit={() => {
                            setKey(moment().unix());
                            setSelectedData(getDayMenu(activeDay));
                            setIsFoodMenu(true);
                          }}
                        />

                        <MealCardX
                          icon={<FaConciergeBell />}
                          title="Dinner"
                          timing={getDayMenu(activeDay)?.dinnerTiming}
                          veg={getDayMenu(activeDay)?.dinner}
                          nonVeg={getDayMenu(activeDay)?.dinnerNonVeg}
                          emptyMessage="Dinner menu not available."
                          onEdit={() => {
                            setKey(moment().unix());
                            setSelectedData(getDayMenu(activeDay));
                            setIsFoodMenu(true);
                          }}
                        />
                      </div>
                    ) : (
                      <EmptyStateContainer className="rounded-xl border border-dashed border-gray-300 bg-gradient-to-br from-slate-50 to-white py-14 px-8 text-center">

                        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50">
                          <MdRestaurantMenu
                            size={32}
                            className="text-primary-color"
                          />
                        </div>

                        <h3 className="text-xl font-semibold text-gray-800">
                          No Menu Available
                        </h3>

                        <p className="mt-2 max-w-md mx-auto text-sm leading-6 text-gray-500">
                          No meal menu has been added for{" "}
                          <span className="font-semibold text-gray-700">
                            {dayNames[activeDay]}
                          </span>
                          . Add menu so tenants can view their meals.
                        </p>

                        <button
                          type="button"
                          onClick={() => {
                            setKey(moment().unix());
                            setSelectedData({ dayOfWeek: activeDay });
                            setIsFoodMenu(true);
                          }}
                          className="mt-8 inline-flex items-center gap-2 rounded-xl bg-primary-color px-6 py-3 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
                        >
                          {/* <MdAdd size={20} /> */}
                          Add Menu
                        </button>

                      </EmptyStateContainer>
                    )}
                    {/* <div className="mt-4 flex justify-end">
                      <UploadBtn
                        type="button"
                        onClick={() => {
                          setIsUploadMenuVisible(true);
                        }}
                      >
                        Upload Menu
                      </UploadBtn>
                    </div> */}
                  </div>
                </>
                {error && !isLoading && selectedProperty && selectedProperty !== 0 && <NotFoundModel />}
              </>
            )
          )}
        </div>
        {/* Upload Menu Action */}
        {isDataLoaded &&
          !isLoading &&
          !error && (

            <div className="my-6">
              <div className=" rounded-xl border border-gray-200 bg-white px-6 py-5">
                <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">

                  {/* Left content */}
                  <div className="flex items-center gap-4">
                    <div>
                      <h3 className="text-sm md:text-base font-semibold text-gray-900">
                        Want to update the entire weekly menu?
                      </h3>

                      <p className="mt-1 text-xs md:text-sm text-gray-500">
                        Upload your menu using an Excel file instead of editing or adding meals individually.
                      </p>
                    </div>
                  </div>

                  {/* Upload button */}
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedData({
                        propId: selectedProperty,
                      });
                      setIsUploadMenuVisible(true);
                    }}
                    className="group inline-flex shrink-0 border border-primary-color/20 items-center justify-center gap-2 rounded-lg bg-primary-color/10 px-5 py-2.5 font-medium text-primary-color hover:text-white transition-all duration-200 hover:bg-primary-color"
                  >
                    {/* <MdOutlineFastfood
                  size={20}
                  className="transition-transform duration-200 group-hover:scale-110"
                /> */}

                    <span>Upload Menu</span>

                    <MdOutlineChevronRight
                      size={20}
                      className="transition-transform duration-200 group-hover:translate-x-1"
                    />
                  </button>

                </div>
              </div>
            </div>
          )}

        {!isRefetching && !isLoading && selectedProperty &&
          selectedProperty !== 0 &&
          apiData.length > 0 &&
          !isFoodMenu && (
            <div className="mt-2 mb-6 rounded-xl border border-gray-200 bg-white px-6 py-5">

              <div className="flex flex-col md:flex-row items-center justify-between gap-4">

                <div>
                  <h3 className="text-base font-semibold text-gray-900">
                    Menu Status
                  </h3>

                  <p className="mt-1 text-sm text-gray-500">
                    {data?.status === 1
                      ? "Published and visible to tenants."
                      : "Draft. Publish when your menu is ready."}
                  </p>
                </div>

                <button
                  onClick={() => setIsPublishMenu(true)}
                  className={`min-w-[180px] rounded-lg px-5 py-2.5 font-medium transition ${data?.status === 1
                    ? "border border-red-200 bg-red-50 text-red-600 hover:bg-red-100"
                    : "bg-[#0078BD] text-white hover:bg-[#00639c]"
                    }`}
                >
                  {data?.status === 1
                    ? "Unpublish Menu"
                    : "Publish Menu"}
                </button>

              </div>

            </div>
          )}

      </div >


    </BoxContainer >
  );
};

const MealCardX = ({
  icon,
  title,
  timing,
  veg,
  nonVeg,
  single,
  emptyMessage,
  onEdit,
}) => (
  <div className="group rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden">

    {/* Header */}

    <div className="flex justify-between items-start px-6 py-5 border-b bg-gradient-to-r from-gray-50 to-white">

      <div className="flex items-center gap-4">

        <div className="w-12 h-12 rounded-xl bg-[#0078BD]/10 text-[#0078BD] flex items-center justify-center text-xl">
          {icon}
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900">
            {title}
          </h3>

          {timing && (
            <div className="flex items-center gap-2 mt-1 text-sm text-gray-500">
              <FiClock size={14} />
              {timing}
            </div>
          )}
        </div>
      </div>
      <button
        onClick={onEdit}
        className="text-[#0078BD] hover:text-blue-700 font-medium text-sm flex items-center gap-1"
      >
        Edit
        <MdOutlineChevronRight />
      </button>
    </div>

    {/* Body */}

    <div className="p-6">
      {single && (
        <ul className="space-y-2">
          {single.split(",").map(item => item.trim())
            .filter(Boolean).map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 text-gray-700"
              >
                <FiCheckCircle
                  className="text-green-500 mt-0.5"
                />
                <span>{item.trim()}</span>
              </li>
            ))}
        </ul>
      )}

      {(veg || nonVeg) && (
        <div className="space-y-5">
          {veg && (
            <div className="rounded-xl border border-green-100 bg-green-50 p-4">
              <div className="flex items-center gap-2 mb-3">
                <span className="w-3 h-3 rounded-full bg-green-500" />
                <span className="font-semibold text-green-700">
                  Veg
                </span>
              </div>
              <ul className="space-y-2">
                {veg.split(",").map(item => item.trim())
                  .filter(Boolean).map((item, i) => (
                    <li
                      key={i}
                      className="flex gap-2 text-gray-700"
                    >
                      <FiCheckCircle className="text-green-500 mt-0.5" />
                      {item.trim()}
                    </li>
                  ))}
              </ul>
            </div>
          )}

          {nonVeg && (
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-3">
                <span className="w-3 h-3 rounded-full bg-red-500" />
                <span className="font-semibold text-red-700">
                  Non-Veg
                </span>
              </div>
              <ul className="space-y-2">
                {
                  nonVeg
                    .split(",")
                    .map(item => item.trim())
                    .filter(Boolean)
                    .map((item, i) => (
                      <li
                        key={i}
                        className="flex gap-2 text-gray-700"
                      >
                        <FiCheckCircle className="text-red-500 mt-0.5" />
                        {item.trim()}
                      </li>
                    ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {!single && !veg && !nonVeg && (
        <div className="py-8 text-center">
          <FiAlertCircle
            size={42}
            className="mx-auto text-gray-300 mb-3"
          />
          <p className="text-gray-500">
            {emptyMessage}
          </p>
        </div>
      )}
    </div>
  </div>
);

// Styled components
//const DayTabsContainer = tw.div`flex overflow-x-auto pb-2 mb-3 scrollbar-hide`;
const DayTabsContainer = tw.div`
  flex
  items-center
  gap-1
  border-b
  border-gray-200
  mt-5
  overflow-x-auto
  scrollbar-hide
`;

const DayTab = tw.button`
  relative
  flex
  items-center
  gap-2
  px-5
  py-3
  text-sm
  font-medium
  whitespace-nowrap
  transition-all
  duration-200
  border-0
  bg-transparent
  cursor-pointer

  ${({ $active }) =>
    $active
      ? "text-primary-color"
      : "text-gray-500 hover:text-gray-800"}

  ${({ $active }) =>
    $active &&
    `
      after:content-['']
      after:absolute
      after:left-3
      after:right-3
      after:bottom-[-1px]
      after:h-[2px]
      after:bg-primary-color
      after:rounded-full
    `}
`;

const EmptyStateContainer = tw.div`bg-white rounded-lg shadow-sm p-8 text-center`;
//const StickyFooter = tw.div`fixed bottom-0 lg:left-56 left-0 right-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end z-10`;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110  py-2.5 text-sm`;

export default FoodMenu;